var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoFechar02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 0.1,
    y: 0.1,
    className: "st0",
    width: 35.8,
    height: 35.8
  }), /*#__PURE__*/React.createElement("g", {
    id: "Close",
    transform: "translate(-4 -4)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M38.8,8.9c1-1.1,1-2.7-0.1-3.7c-1-1-2.6-1-3.7,0l-13,13L9,5.2c-1.1-1-2.7-1-3.7,0.1c-1,1-1,2.6,0,3.7l13,13 l-13,13c-1.1,1-1.1,2.7-0.1,3.7s2.7,1.1,3.7,0.1c0,0,0,0,0.1-0.1l13-13l13,13c1.1,1,2.7,1,3.7-0.1c1-1,1-2.6,0-3.7l-13-13 L38.8,8.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFechar02);
export default __webpack_public_path__ + "static/media/ico-fechar-02.706ad11cc10fb26f0686648f8ae57c49.svg";
export { ForwardRef as ReactComponent };